module.exports = __webpack_public_path__ + "img/car-battery.1b2daed8.svg";